<a [href]="link" target="_blank" (mouseenter)="setHoverStatus(true)" (mouseleave)="setHoverStatus(false)">
  <div class="download-icon {{isHover ? 'hover' : ''}}">
    <img *ngIf="!isHover" src="assets/images/icon/ic-arrow-down@2x.png" width="10px">
    <img *ngIf="isHover" src="assets/images/icon/ic-arrow-down_@2x.png" width="10px">
  </div>
  <span>{{countTopic}}.{{countDetail}} {{text}}</span>
</a>